"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Theme = void 0;
var React = require("react");
var styled_components_1 = require("styled-components");
var theme_1 = require("../../theme");
var Theme = function (_a) {
    var children = _a.children;
    return (React.createElement(styled_components_1.ThemeProvider, { theme: theme_1.theme }, children));
};
exports.Theme = Theme;
exports.Theme.displayName = 'Theme';
//# sourceMappingURL=index.js.map